import * as React from 'react';
import { ListProps } from 'antd/lib/list';
import { List } from 'antd';

import './style/list.less';

export type NiListProps<T> = ListProps<T> & {};

export type NiListState = {};

export class NiList<T> extends React.Component<NiListProps<T>, NiListState> {
  render() {
    const props = this.props;
    const state = this.state;
    const { pagination } = props;
    let isPageintion = false;
    if (
      pagination &&
      pagination.total !== undefined &&
      pagination.pageSize !== undefined
    ) {
      isPageintion = pagination.total > pagination.pageSize;
    }

    return (
      <List
        {...props}
        className={`ni-list ${isPageintion ? 'page-margin' : ''} ${this.props.className
          }`}
        // style={{ marginBottom: props.pagination !== false ? '70px' : '16px' }}
        bordered
      />
    );
  }
}
